import { useTranslation } from '@hotjar/translations';
import type { UseTrafficCoverage } from '@hotjar/webapp/hooks/useTrafficCoverage';
import { TrafficBar } from '@hotjar/webapp/features/Billing/TrafficRecommendationModal/components/TrafficBar';
import type { Site } from '@hotjar/site';
import { ObserveContextualBar as S } from './ObserveContextualBar.styles';
import { FeatureBar } from '../FeatureBar/FeatureBar';

type ContextualBar = {
  title: string;
  description: string;
  illustration: string;
};

type ObserveContextualBarProps = {
  coverageProps: UseTrafficCoverage;
  site: Site;
  contextualBar: ContextualBar | null;
};

export const ObserveContextualBar = ({
  coverageProps,
  site,
  contextualBar,
}: ObserveContextualBarProps): JSX.Element => {
  const { t } = useTranslation('billing', { keyPrefix: 'plan-select-upsell-modal' });

  const getTrafficBarText = () => {
    let titleKey = 'traffic-bar';
    let subtitleKey = null;

    if (coverageProps.coveragePercentage === 100) {
      titleKey = 'traffic-bar_full-coverage_title';
      subtitleKey = 'traffic-bar_full-coverage_sub-title';
    }

    if (coverageProps.days < 1) {
      titleKey = 'traffic-bar_measuring_title';
      subtitleKey = 'traffic-bar_measuring_sub-title';
    }

    if (coverageProps.isError) {
      titleKey = 'traffic-bar_no-data_title';
      subtitleKey = 'traffic-bar_no-data_sub-title';
    }

    return (
      <S.TrafficBarTitleWrapper>
        <S.Text as="p" textType="subtitle1">
          {t(titleKey)}
        </S.Text>
        {subtitleKey && (
          <S.Text as="p" textType="body1" textColor="text_light">
            {t(subtitleKey)}
          </S.Text>
        )}
      </S.TrafficBarTitleWrapper>
    );
  };

  if (contextualBar) {
    return <FeatureBar {...coverageProps} {...contextualBar} />;
  }

  return (
    <TrafficBar {...coverageProps} hasDivider={false} site={site}>
      {getTrafficBarText()}
    </TrafficBar>
  );
};
